import React from 'react'
import './contact.css'
import HeaderAbout from '../../component/headerabout/HeaderAbout'
import headerimage from '../../images/header_bg_2.jpg'
import { MdOutlineEmail } from "react-icons/md";
import { PiMessengerLogo } from "react-icons/pi";
import { FaWhatsapp } from "react-icons/fa";


function Contact() {
  return (
    <>
    
      <HeaderAbout title="get in toch" image={headerimage}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod porro quidem ducimus tempora pariatur ut id officia hic quaerat? Sapiente quam quasi officiis ea alias esse ad temporibus necessitatibus unde.
      </HeaderAbout>

      <section className='contact'>
        <div className="container contact__container">
          <div className="contact__wrapper">

            <a href="https://mail.google.com/" target='_blank'><MdOutlineEmail/></a>
            <a href="https://m.me/ernest_achiever" target='_blank'><PiMessengerLogo/></a>
            <a href="https://wa.me/+201111829580" target='_blank' rel='noreferrer noopener'><FaWhatsapp/></a>

          </div>
        </div>
      </section>
    </>
  )
}

export default Contact